import request, { FormDataHeader } from '@/utils/request'
import { UserInfo, NativePayInfo } from '@/types/user'

const mockUser = {
  access_token: '8a034a3ffbe9db140b18162b9c1a63f6',
  avatar: '',
  guid: '0D505968-21E8-D6A6-B3B0-AFEF6FED171D',
  id: 3,
  name: '郑晓欢',
  username: 'zhengxiaohuan',
}

type User = typeof mockUser

export function login(avg: { username: string; password: string }): Promise<User> {
  return request.post('/home/login', avg, {
    headers: FormDataHeader,
  })
}

export function GetUserInfo(): Promise<UserInfo> {
  return request.get('/api/agri/common/user')
}

export function getWechatNativePay(order_no: string): Promise<NativePayInfo> {
  return request.post(
    '/api-pay/order/app/native_unify',
    {
      order_no,
    },
    {
      headers: FormDataHeader,
    }
  )
}
